// Catálogo del aviso en pantalla: viaja el `noticeType` y cada conector lo traduce a lo suyo. Son
// los mismos diez avisos de Mensajes al cliente, con su texto.
import { DeviceNotifyIntensityEnum } from '@fiado/type-kit/bin/mdm/enums/DeviceNotifyIntensityEnum';
import { MDM_NOTICE_TEXTS, type MdmNoticeText } from '../customerMessages/mdmNoticeTexts';
import { MDM_NOTICE_LABEL, MDM_NOTICE_TYPES, type MdmNoticeType } from '../customerMessages/types';

/** Los avisos del combo, en orden de ciclo: el operador busca un momento de la mora, no una letra. */
export const MDM_NOTICE_OPTIONS: readonly { value: MdmNoticeType; label: string }[] =
    MDM_NOTICE_TYPES.map((noticeType) => ({
        value: noticeType,
        label: MDM_NOTICE_LABEL[noticeType],
    }));

/** Si el valor es uno de los diez avisos del catálogo. */
export function isMdmNoticeType(value: string): value is MdmNoticeType {
    return (MDM_NOTICE_TYPES as readonly string[]).includes(value);
}

/** El texto del aviso tal como lo manda el conector al equipo. */
export function noticeTextOf(noticeType: MdmNoticeType): MdmNoticeText {
    return MDM_NOTICE_TEXTS[noticeType];
}

/** La intensidad con la que abre el diálogo: la menos invasiva de las dos. */
export const DEFAULT_NOTIFICATION_INTENSITY = DeviceNotifyIntensityEnum.BANNER;

/** Cómo se lee cada intensidad en el diálogo. */
export const MDM_NOTIFY_INTENSITY_LABEL: Record<DeviceNotifyIntensityEnum, string> = {
    [DeviceNotifyIntensityEnum.BANNER]: 'Banner · aviso discreto arriba de la pantalla',
    [DeviceNotifyIntensityEnum.FULLSCREEN]: 'Pantalla completa · el cliente tiene que descartarlo',
};
